/* global bassConfig */

/**
 * Function to render the AOY Leaderboard Widget.
 */
document.addEventListener('DOMContentLoaded', () => {
  // Bail entirely if we're not using the correct config/setup.
  if (
    !window.bassBlocks
    || !bassConfig
    || !bassConfig.bass_leaderboard
    || !bassConfig.bass_persons
  ) {
    return;
  }

  const {
    bass_persons: { tms = false },
    bass_leaderboard: { url } = {},
  } = bassConfig;

  const statsApp = document.querySelector('#react-app--historical-stats');

  /**
   * Use a Mutation Observer to correct stat link hrefs after React table renders.
   * `bassBlocks` render method (called below) executes asynchronously without returning a Promise.
   * So we're observing the root div's mutations and running code once the table renders.
   */
  if (statsApp) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const mutantNodes = mutation.addedNodes;

        // Look for the stats table.
        if (mutantNodes.length > 0 && mutantNodes[0].localName === 'table') {
          const table = mutantNodes[0];
          const rows = table.querySelectorAll('tr');
          const anglerRoute = window.location.pathname;

          const statLinkDict = {
            'Total Tournaments': 'all',
            'Classic Appearances': 'classic',
            'Classic Wins': 'classicwins',
            'Time in Money': 'money',
            '1st Place Finishes': 'first',
            '2nd Place Finishes': 'second',
            '3rd Place Finishes': 'third',
            'Top 10 Finishes': 'top10',
            'Top 20 Finishes': 'top20',
            'Top 30 Finishes': 'top30',
          };

          rows.forEach((row) => {
            // Use row's stat name to lookup the approriate filter link param.
            const statName = row.children[0]?.children[0]?.innerText;
            const linkString = statLinkDict[statName];

            // If the stat name has a corresponding filter param, update link's href.
            if (linkString) {
              row.children[1].children[0]
                .setAttribute('href', `${anglerRoute}stats/?filter=${linkString}`);
            }
          });

          // Our work here is done, stop observing mutations.
          observer.disconnect();
        }
      });
    });

    observer.observe(statsApp, {
      characterData: true,
      childList: true,
      subtree: true,
    });
  }

  // Kickoff render.
  window.bassBlocks
    .setApiBase(url)
    .render('react-app--historical-stats', 'HistoricalStats', { anglerId: tms });
});
